import React from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { Grid, TextField } from '@mui/material'
import CustomBasicSelect from './CustomBasicSelect'
import { getError } from './event'
import { prefixOptions } from '../constant'
import { setExaminerDetail } from 'src/redux/slices/eExamination'

const TitleInput = ({
  index,
  obj,
  isDisabled = false,
  sm = 6,
  md = 'unset',
}) => {
  const dispatch = useDispatch()
  const { value, formError } = useSelector(
    (state) => ({
      value: state.eExamination.examiners[index][obj],
      formError: state.eExamination.formError[index],
    }),
    shallowEqual
  )
  return (
    <Grid item md={md} sm={sm} xs={12}>
      <CustomBasicSelect
        sx={{
          '& .MuiAutocomplete-inputRoot': {
            pl: 1,
            height: 50,
            background: '#FFFFFF',
          },
        }}
        labelText="คำนำหน้าชื่อ"
        required
        ShowTextError={getError(formError, 'prefix')}
        textError={getError(formError, 'prefix')}
        options={prefixOptions}
        getOptionLabel={(option) => option.label}
        handleChange={(e, selected) => {
          dispatch(
            setExaminerDetail({ index, obj, value: selected?.value || '' })
          )
        }}
        handleInputChange={(e, value) =>
          dispatch(dispatch(setExaminerDetail({ index, obj, value: value })))
        }
        inputValue={value || ''}
        renderInput={(params) => (
          <TextField {...params} placeholder="กรุณาเลือก" />
        )}
        isHideSort={true}
        noOptionsText={'กรุณาเลือกคำนำหน้าชื่อ'}
        disabled={isDisabled}
      />
    </Grid>
  )
}

export default TitleInput
